import { defineComponent, h } from 'vue';
import { du, t } from '@/ui/i18n/i18n';
import { InspectionApproval } from '@/entities/approvals/model';
import TableBox from '@/ui/components/inspectionReport/items/table/TableBox.vue';
import { tag } from '@/ui/components';
import { approvalStatusToText } from '@/ui/dictionary';
import { useApproval } from '@/ui/concerns/approval/useApproval';

interface ApprovalProps {
  approval: InspectionApproval;
}

export default defineComponent<ApprovalProps>({
  name: 'Approval',
  props: ['approval'],
  setup(props) {
    const { approvalStatusToTagType } = useApproval();

    return function render() {
      return h('div', { class: 'inspection-report__approvals-page' }, [
        h('div', { class: 'inspection-report__approvals-page-title' }, [t('inspection-report.approval.title')]),
        h('table', { class: 'inspection-report__table mt-2' }, [
          h('tbody', [
            h('tr', { attrs: { 'data-test': 'approvals-tr' } }, [
              h(TableBox, [
                t('inspection-report.approval.status'),
              ]),
              h(TableBox, [
                h('div', [tag(
                  approvalStatusToTagType[props.approval.status],
                  approvalStatusToText(props.approval.status),
                )]),
              ]),
            ]),
            h('tr', { attrs: { 'data-test': 'approvals-tr' } }, [
              h(TableBox, [
                t('inspection-report.approval.approver'),
              ]),
              h(TableBox, [
                h('div', props.approval.approver?.data.name ?? '-'),
              ]),
            ]),
            h('tr', { attrs: { 'data-test': 'approvals-tr' } }, [
              h(TableBox, [
                t('inspection-report.approval.date'),
              ]),
              h(TableBox, [
                h('div', du(props.approval.updated_at, 'shortDateTime')),
              ]),
            ]),
            h('tr', { attrs: { 'data-test': 'approvals-tr' } }, [
              h(TableBox, [
                t('inspection-report.approval.comment'),
              ]),
              h(TableBox, [
                h('div', props.approval.comment || '-'),
              ]),
            ]),
          ]),
        ]),
      ]);
    };
  },
});
